export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// Point to local login page — no external OAuth redirect
export const getLoginUrl = (returnPath?: string) => {
  const base = "/login";
  if (returnPath) {
    return `${base}?return=${encodeURIComponent(returnPath)}`;
  }
  return base;
};
